import { Column } from '@ant-design/charts'
import { ColumnConfig } from '@ant-design/plots/es/components/column'
import { Flex } from 'antd'
import React, { useMemo } from 'react'

import SectionTitle from '../section-title'

export interface ChatterPerformanceMessageCountProps {
  data: { dateStr: string, name: string, count: number }[]
}

export default function ChatterPerformanceMessageCount({ data }: ChatterPerformanceMessageCountProps) {
  const config = useMemo(() => {
    const config: ColumnConfig = {
      data,
      xField: 'dateStr',
      yField: 'count',
      seriesField: 'name',
      colorField: 'name',
      axis: {
        x: {
          labelAutoRotate: false,
        },
      },
      height: 320,
      style: { maxWidth: 3, minHeight: 1 },
      legend: {
        color: {
          itemMarker: 'circle',
          title: false,
          position: 'bottom',
          rowPadding: 5,
          layout: {
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          },
        },
      },
    }

    return config
  }, [data])

  return (
    <Flex vertical gap={8}>
      <SectionTitle
        title="Message count"
        tooltip="Total messages, PPVs, and unlocked PPVs that the Chatter has sent"
      />
      <Column {...config} />
    </Flex>
  )

}